const hasLowercase = (value: string) => /^(?=.*[a-z]){1}/.test(value);

export default hasLowercase;
